import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import News from './pages/News';
import Vacancies from './pages/Vacancies';
import History from './pages/History';
import Reserves from './pages/Reserves';
import Contractors from './pages/Contractors';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/news" element={<News />} />
            <Route path="/vacancies" element={<Vacancies />} />
            <Route path="/history" element={<History />} />
            <Route path="/reserves" element={<Reserves />} />
            <Route path="/contractors" element={<Contractors />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
